import { colors } from '@styles';
import { flexMixin, textMixin } from '@styles/mixins';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 360px;
    background: #f7f7f7;
    border-radius: 5px;
    z-index: 1105;
    overflow: hidden;
    display: flex;
    padding: 40px 30px;
`;
export const BlurredContent = styled.div`
    flex: 1;
    display: flex;
    ${flexMixin('column', 'center', 'center')}
    position: relative;
`;
export const CloseBtn = styled.button`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    color: #8f8f8f;
    border: none;
    background: ${colors.white};
    height: 25px;
    ${flexMixin('row', 'center', 'flex-start')}
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
    &:hover {
        color: #5e5e5e;
    }
`;
export const StyledButtonLink = styled.button`
    ${flexMixin('row', 'center', 'center')}
    cursor: pointer;
    height: 40px;
    width: 100%;
    background: ${colors.primaryBg};
    border-radius: 5px;
    border: none;
    gap: 5px;
    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        text-align: center;
        color: ${colors.cleanWhite};
    }
    &:hover {
        background: #97267d;
    }
`;
export const BtnWrapper = styled.div`
    margin-top: 15px;
    width: 100%;
    ${flexMixin('column', 'center', 'center')}
    gap: 10px;
`;
export const Title = styled.div`
    width: 100%;
    text-align: center;
    ${textMixin({
        fontSize: '16px',
        fontWeight: 500,
    })};
`;
export const SubTitle = styled.div`
    width: 100%;
    text-align: left;
    padding-top: 10px;
    ${textMixin({
        fontSize: '13px',
        fontWeight: 400,
    })};
`;
export const StyledButtonQr = styled.button`
    ${flexMixin('row', 'center', 'center')}
    cursor: pointer;
    height: 40px;
    width: 100%;
    background: ${colors.white};
    border-radius: 5px;
    border: 1px solid ${colors.primaryBg};
    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        text-align: center;
        color: ${colors.blackText};
    }
    &:hover {
        border: 2px solid #97267d;
    }
`;
export const QrWrapper = styled.div`
    margin-top: 20px;
    ${flexMixin('column', 'center', 'center')}
    gap: 10px;
    padding: 15px;
    background: ${colors.white};
    border-radius: 8px;
    border: 1px solid #e0e0e0;
`;

export const QrText = styled.div`
    ${textMixin({
        fontSize: '12px',
        fontWeight: 400,
    })};
    color: ${colors.blackText};
    text-align: center;
`;
